import React from 'react';
import './UserDisplay.scss';
import { defaultUserDisplayProps, userDisplayProps } from './UserDisplayProps';
import UserImage from './UserImage/UserImage';

export default class UserDisplay extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = userDisplayProps;

    static defaultProps = defaultUserDisplayProps;

    render() {
        let usernameText = this.props.customText || `${this.props.username}`;
        return (
            <div className={`component-Content-User-UserDisplay`}>
                <UserImage
                    image={this.props.image}
                    iconSize={this.props.imageSize}
                />
                <div data-qa="author-name" className="contentAuthor">
                    {usernameText}
                </div>
            </div>
        );
    }
}
